module.exports = __webpack_public_path__ + "img/1.f0f7734d.png";